import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import CircleBackground from '../components/general/CircleBackground';
import { DARK_BLUE_COLOR } from '../components/general/constants/_colors';

const StyledSplash = styled.div`
  background-color: ${DARK_BLUE_COLOR};
  color: #fff;
  text-align: center;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

const ContentContainer = styled.div`
  flex-grow: 2;
  display: flex;
  align-items: center;
  width: 480px;

  > div {
    width: 100%;
  }
`;

const Splash = ({ children }) => (
  <StyledSplash>
    <ContentContainer>
      <div>{children}</div>
    </ContentContainer>
    <CircleBackground height="150px" width="90%" color="white" />
  </StyledSplash>
);

Splash.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Splash;
